module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_location@2x-ce23a35e6c71357014ebee67b347afca.webp";